<template>
	<div id="StepWizardLogoConfig" class="text-left">
		<div class="title-area">
			<h4>{{ stepName }}</h4>
			<p>Qual opção mais combina no menu?</p>
		</div>
		<div class="input-area pb-5">
			<div
				v-if="!loadedLogos"
				class="row justify-content-center align-items-center"
			>
				<div class="col-10 text-center py-5 mt-5">
					<h4>Carregando opções...</h4>
				</div>
			</div>
			<div class="row align-items-center" v-else>
				<div
					class="col-12 col-md-6 mb-3"
					v-for="option in logoSetupList"
					:key="option.id"
				>
					<div
						class="card py-2 px-4 item--logo"
						:class="[
							checkSelected(option) ? 'selected' : '',
							getThemeMode,
						]"
						@click="selectLogo(option)"
					>
						<div class="row align-items-center h-100">
							<div
								class="col-auto pr-0"
								v-if="option.use_file != null"
							>
								<img
									:class="option.image_style"
									:src="option.use_file == 'avatar' ? option.file_url : normalizeLogoUrl(option.file_url)"
									alt
								/>
							</div>
							<div class="col">
								<span v-if="option.show_name == 1">{{
									siteName
								}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-6 text-center pb-5">
					<label for="inputLogoUpload" class="input-button">
						<div class="align-items-center upload--item">
							<p class="m-0">
								<i class="fas fa-upload"></i>
							</p>
							<p class="m-0">Enviar arquivo</p>
						</div>
					</label>
				</div>
			</div>
		</div>
		<input
			type="file"
			class="d-none"
			accept=".jpeg, .png, .jpg, .gif"
			name="inputLogoUpload"
			id="inputLogoUpload"
			ref="inputLogoUpload"
			@change="uploadArchive"
		/>
	</div>
</template>

<script>
	import uploadFiles from "@/mixins/uploadFiles";
	import axios from "axios";
	import baseImage from "@/components/atoms/BaseImage";
	export default {
		name: "StepWizardLogoConfig",
		props: {
			stepName: {
				type: String,
				required: false,
			},
		},
		data() {
			return {
				avatarUrl: "",
				fileToUpload: null,
				logoSetupList: [],
				logoUrl: "",
				loadedLogos: false,
				selectedLogoSetup: null,
				siteName: ''
			};
		},
		components: {
			baseImage,
		},
		mixins: [uploadFiles],
		async created() {
			this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [true]);
			this.avatarUrl = await this.getProfilePictures();
			this.populateLogoSetupList();
		},
		mounted() {
			this.$emit("updateStep");
			this.selectedLogoSetup = this.$store.state.wizard.dataSite.logoSelected;
			this.logoUrl = this.$store.state.wizard.dataSite.logoPicture;
			this.siteName = this.$store.state.wizard.dataSite.siteName;
		},
		methods: {
			getProfilePictures() {
				return new Promise((resolve) => {
					if (this.$store.state.wizard.dataSite.avatarPicture.length > 0) {
						resolve(this.$store.state.wizard.dataSite.avatarPicture);
					} else {
						let token = localStorage.getItem("jwt");
						let siteId = localStorage.siteId;
						axios({
							method: "get",
							url: `${process.env.ROOT_API}/api/site/${siteId}/profile/get/picture`,
							data: "",
							headers: {
								Authorization: "Bearer " + token,
							},
						})
						.then((response) => {
							if (response.data.length > 0) {
								resolve(response.data[0].picture);
							} else resolve("");
						})
						.catch((error) => {
							console.log(error);
						});
					}
				});
			},
			logoSetupItemConstructor(item){
				if(item.use_file == 'avatar'){
					item = { ...item, file_url: this.avatarUrl};
				}else if(item.use_file == 'logo'){
					item = { ...item, file_url: this.logoUrl};	
				}
				return item;
			},
			async populateLogoSetupList() {
				this.logoSetupList = this.$store.state.wizard.dataSite.listLogo;
				if (this.logoSetupList.length == 0) {
					this.logoSetupList = await this.getLogos();
				}
				let mappedLogSetupList = []
				if(this.avatarUrl){ 
					let filteredAvatarOptions = this.logoSetupList.filter(item => item.use_file == "avatar")
					mappedLogSetupList = [...filteredAvatarOptions]
				}
				if(this.logoUrl){
					let filteredLogoOptions = this.logoSetupList.filter(item => item.use_file == "logo")
					mappedLogSetupList = [...mappedLogSetupList, ...filteredLogoOptions]
				}
				let filteredNoImageLogoOptions = this.logoSetupList.filter(item => item.use_file == null)
				mappedLogSetupList = [...mappedLogSetupList, ...filteredNoImageLogoOptions].flat();
				this.logoSetupList = mappedLogSetupList.map(item => this.logoSetupItemConstructor(item));
				this.loadedLogos = true;
			},
			getLogos() {
				return new Promise((resolve) => {
					let token = localStorage.getItem("jwt");
					axios({
						method: "get",
						url: `${process.env.ROOT_API}/api/logo`,
						data: "",
						headers: {
							Authorization: "Bearer " + token,
						},
					})
						.then((response) => {
							resolve(response.data.data);
						})
						.catch((error) => {
							resolve([]);
						});
				});
			},
			async uploadArchive(){
				this.fileToUpload = this.$refs.inputLogoUpload.files;
				let images = await this.uploadImages(this.fileToUpload);
				this.logoUrl = images[0];
				this.addNewLogoOptions();
			},
			addNewLogoOptions(){
				let itemOne = {
					'box_style': null,
					'id': 7,
					'image_style': null,
					'show_name': 0,
					'text_style': null,
					'use_file': "logo",
					'file_url': this.logoUrl
				};
				let itemTwo = {
					'box_style': null,
					'id': 6,
					'image_style': null,
					'show_name': 1,
					'text_style': null,
					'use_file': "logo",
					'file_url': this.logoUrl
				}
				this.logoSetupList.push(itemOne);
				this.logoSetupList.push(itemTwo);
			},
			selectLogo(item) {
				this.selectedLogoSetup = item;
				this.$store.dispatch("SELECT_LOGO", [
					this.selectedLogoSetup,
					this.logoUrl,
					this.logoSetupList,
				]);
			},
			checkSelected(item) {
				return item == this.selectedLogoSetup;
			},
			normalizeLogoUrl(picture){
				return process.env.CDN_URL + picture
			}
		},
		computed: {
			getThemeMode() {
				return 'light';
			},
			
		},
		watch: {
			selectedLogoSetup() {
				if (this.selectedLogoSetup) {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
				} else {
					this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
				}
			},
			avatarPicture() {
				this.$store.dispatch("UPDATE_AVATAR_PICTURE", [this.avatarPicture]);
			},
		},
		destroyed() {},
	};
</script>

<style>
	.upload--item {
		background-color: #ededed;
		color: #707070;
		padding: 10px;
	}
	.item--logo {
		height: 84px;
		font-family: "Montserrat", sans-serif;
		padding-left: 20px;
		padding-right: 20px;
		cursor: pointer;
	}
	.item--logo.selected {
		border: 2px solid var(--main-color);
	}
	.item--logo img {
		height: 40px;
		display: inline-block;
	}
	.dark {
		background-color: #222222;
		color: #ffffff;
	}
	.light {
		background-color: #ffffff;
		color: #222222;
	}
	.input-button {
		width: 100%;
		cursor: pointer;
	}
	.loading-component {
		height: 250px;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardLogoConfig.vue